import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonComponent } from '../ButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import './ErrorBoundaryPage.scss';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { STATUSES } from '../../views/login/Login';
import { APPLICATION_VIEW_BASE_VIEW, APPLICATION_VIEW_STEPS } from '../application-view/ApplicationViewAsideMenu';

export const ErrorBoundaryPage = (): JSX.Element => {
	const navigate = useNavigate();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const applicationStatus = authUser?.userData?.applicationStatus;

	const notApprovedApplication = applicationStatus === STATUSES.DRAFT
		|| applicationStatus === STATUSES.IN_REVIEW
		|| applicationStatus === STATUSES.SUBMITTED;

	// window.location.href = ('/error');
	return (
		<div className="d-flex flex-column align-items-center justify-content-center error-boundary-container">
			<FontAwesomeIcon icon={faTriangleExclamation} className="text-danger h-75px"/>
			<h1 className="mb-20 mt-5">Something went wrong</h1>
			<ButtonComponent
				buttonName={notApprovedApplication ? 'Go back to form' : 'Go to dashboard'}
				onButtonClick={(): void => {
					if (notApprovedApplication) {
						navigate(`/${APPLICATION_VIEW_BASE_VIEW}/${APPLICATION_VIEW_STEPS.BUSINESS_DETAILS}`);
					} else {
						navigate('/');
					}
				}}
			/>
		</div>
	);
};
